import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
interface CardProps {
  children: ReactNode;
  className?: string;
  id?: string;
  labelledBy?: string;
  as?: "div" | "section" | "article" | "aside";
}
export function Card({
  children,
  className,
  id,
  labelledBy,
  as: Tag = "div"
}: CardProps) {
  return <Tag id={id} aria-labelledby={labelledBy} className={twMerge("rounded-card border-3 border-line bg-surface shadow-brutal", className)} data-id="element-1190" data-mp="d3q47e80z0ad">
      {children}
    </Tag>;
}